type AttrKeys = keyof typeof CHANGE_PASSWORD_POPUP_ATTRIBUTES_CONSTANT;

export const CHANGE_PASSWORD_POPUP_ATTRIBUTES_CONSTANT = {
  email: {
    type: 'email',
    key: 'email',
    label: 'Email',
  },
  newPassword: {
    type: 'password',
    key: 'new_password',
    label: 'New Password',
  },
  confirmPassword: {
    type: 'password',
    key: 'confirm_password',
    label: 'Confirm Password',
  },
} as const;

export const CHANGE_PASSWORD_POPUP_MESSAGE_CONSTANT = {
  [CHANGE_PASSWORD_POPUP_ATTRIBUTES_CONSTANT.confirmPassword.key as AttrKeys]: {
    pattern: '',
    confirmPasswordValidator: 'Passwords do not match',
  },
};
